export default {
    relativeFill: {
        zIndex: 999,
        position: "relative",
        width: "100%",
        height: "100%"
    } as React.CSSProperties,
    fixedFill: {
        position: "fixed",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
    } as React.CSSProperties,
    absoluteFill: {
        position: "absolute",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
    } as React.CSSProperties,
};